<div class="h-screen flex flex-col space-y-10 pt-10 lg:space-y-20 lg:pt-30 justify-center items-center bg-slate-200">
    
    <app-countdown-timer 
        [minutes]="3" 
        [seconds]="0" 
        (countdownCompleted)="onTimeout()"
    ></app-countdown-timer>
    
    <div class=" space-y-3 text-gray-700">
        <p class="text-base lg:text-lg font-semibold">Para concluir com o pagamento: </p>
        <ol class="list-decimal list-inside ml-4 lg:ml-6 space-y-1 text-sm lg:text-base">
            <li *ngFor="let step of steps;">
                {{step}}
            </li>
        </ol>
    </div>

</div>